import { TrendingUp, ShoppingBag, FileText, Users, Mail, Play, MessageSquare } from "lucide-react";

const Stat = ({ icon: Icon, label, value, testid, sub }) => (
  <div className="tacc-card p-6 md:p-8" data-testid={testid}>
    <Icon size={22} className="text-[#B45309] mb-6" strokeWidth={1.3} />
    <div className="font-display text-4xl md:text-5xl tracking-tight">{value}</div>
    <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#78716C] mt-2">{label}</div>
    {sub && <div className="font-mono text-[9px] tracking-[0.15em] uppercase text-[#555] mt-1">{sub}</div>}
  </div>
);

export const AdminStats = ({ stats: s }) => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
    <Stat icon={TrendingUp} label="Revenue (paid)" value={`$${s.revenue ?? 0}`} testid="stat-revenue" />
    <Stat icon={ShoppingBag} label="Paid Orders" value={s.paid_orders ?? 0} testid="stat-paid" />
    <Stat icon={ShoppingBag} label="Checkouts started" value={s.total_orders ?? 0} testid="stat-orders" sub="opened Stripe, most never pay" />
    <Stat icon={FileText} label="B2B Quotes" value={s.quotes ?? 0} testid="stat-quotes" />
    <Stat icon={Users} label="Members" value={s.members ?? 0} testid="stat-members" />
    <Stat icon={Mail} label="Subscribers" value={s.subscribers ?? 0} testid="stat-subs" />
    <Stat icon={Play} label="Previews (30d)" value={s.previews_30d ?? 0} testid="stat-previews" />
    <Stat icon={MessageSquare} label="Stories · pending" value={s.pending_stories ?? 0} testid="stat-stories" />
  </div>
);
